import React from "react";
import ReactDOM from "react-dom/client";
import { hydrateRoot, createRoot } from "react-dom/client";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";

const AppTree = (
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <App />
  </GoogleOAuthProvider>
);

const rootElement = document.getElementById("root");

if (navigator.userAgent.includes("ReactSnap")) {
  document.documentElement.setAttribute(
    "data-snap-path",
    window.location.pathname.replace(/\/+$/, "") || "/"
  );
}

if (rootElement.hasChildNodes() && !window.__RF_SKIP_HYDRATE__) {
  hydrateRoot(rootElement, AppTree);
} else {
  rootElement.innerHTML = "";
  createRoot(rootElement).render(AppTree);
}